import { R, createStyles } from '@traveloka/district-ui';

R.color = {
  ...R.color,

  brand: '#F15025',

  uiLightStain: '#f6f6f6',
  uiOrangePrimary: '#f96d01',

  uiBlueDark: '#0770cd',

  background: '#e6eaed',
  textPrimary: '#434343',
  textSecondary: '#8f8f8f',

  error: '#f44240',
};

R.style = {
  ...R.style,
  ...createStyles(R.color),
  buttonMainCta: {
    ...R.style.buttonMainCta,
    buttonColors: {
      ...R.style.buttonMainCta.buttonColors,
      disabled: '#b4b4b4',
    },
    textColors: {
      ...R.style.buttonMainCta.textColors,
      disabled: R.color.uiLightPrimary,
    },
  },
  buttonBrandPrimary: {
    ...R.style.buttonMainCta,
    buttonColors: {
      ...R.style.buttonMainCta.buttonColors,
      active: R.color.brand,
    },
  },
  buttonBrandSecondary: {
    ...R.style.buttonMainCta,
    buttonColors: {
      ...R.style.buttonMainCta.buttonColors,
      active: '#f6f6f6',
    },
    textColors: {
      ...R.style.buttonMainCta.textColors,
      active: R.color.brand,
    },
  },
};

export default R;
